// src/data/navItems.js
export const navItems = [
  { href: '#solutions', label: 'Solutions' },
  { href: '#case-studies', label: 'Case Studies' },
  { href: '#methodology', label: 'Methodology' },
  { href: '#company', label: 'Company' },
  { href: '#contact', label: 'Get Started' }
];